<template>
  <PageComponents :page="page" v-if="page"/>
</template>

<script>
// @ is an alias to /src
import data from '@/assets/json/lang.json'
import PageComponents from '../components/PageComponents'

import global from '../assets/js/app.js';

export default {
  name: 'langView',
  components: {
      PageComponents
  },
  methods: {
      checkType(type, check) {
          if(check === type) {
              return true;
          }
          return false;
      },
      getImgUrl(img) {
          return require('../assets/img/'+img)
      }
  },
  mounted() {
      global.init();
  },
  data() {
      return {
          page: data,
      };
  }
}
</script>